import { BaseService } from '@services/BaseService'

const resource = 'calendar'

class CalendarService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const calendarService = new CalendarService()
